module.exports = __webpack_public_path__ + "static/img/pinggu.e4541467.png";